import React from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import HeroSection from "../../components/HeroSection/HeroSection";
import HeroCaption from "../../components/HeroCaption/HeroCaption";
import GrievanceCellResponsive from "../../components/GrievanceCellResponsive/GrievanceCellResponsive";

const GrievanceCellPage = () => {
	return (
		<PageWrapper className="mt-n6">
			<HeroSection className="bg-page-background-11">
				<HeroCaption
					title="Grievance Cell"
					position="bottom-left"
					breadcrumb={true}
					breadcrumbPrefix="Home"
				/>
			</HeroSection>
			<GrievanceCellResponsive />
		</PageWrapper>
	);
};

export default GrievanceCellPage;
